import React, { useRef, useState } from "react";
import { Cropper, CropperRef } from "react-advanced-cropper";
import "react-advanced-cropper/dist/style.css";
import { getCroppedImg } from "../../utils/getCroppedImage"; // Updated utility function
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { usePostApiMutation } from "../../utils/customer/customerTaskTable";
import { NODE_URL } from "../../utils/constants";

const CropComponent = ({ tempSelectedFile, setSelectedFile, onClose, handleFieldChange }) => {
  const cropperRef = useRef(null);
  const [image, setImage] = useState(tempSelectedFile);

  const [
    Attachment,
    {
      isSuccess: isAttachmentSuccess,
      data: AttachmentResponseData,
      isLoading: isAttachmentLoading,
      isError: isAttachmentError,
      error: AttachmentErrorResponse,
    },
  ] = usePostApiMutation();

  const handleCrop = async (event) => {
    const cropper = cropperRef.current;
    if (cropper) {
      const canvas = cropper.getCanvas();
      if (canvas) {
        canvas.toBlob(
          async (blob) => {
            const croppedURL = await getCroppedImg(blob, 0.7); // Compress cropped blob

            const UploadFile = new FormData();
            UploadFile.append("file", croppedURL);
            try {
              const response = await Attachment({ data: UploadFile, url: `${NODE_URL}static/upload` });
              if (response) {
                setSelectedFile(response?.data?.data?.view_url);
                handleFieldChange("general_info", "company_logo", response?.data?.data?.view_url);
              }
            } catch (error) {
              console.log(error);
            }
            onClose();
          },
          "image/jpeg",
          0.7
        ); // Compression quality
      }
    }
  };

  const handleCancel = () => {
    setSelectedFile(null);
    onClose();
  };

  return (
    <div className="flex items-center flex-col justify-between gap-2">
      <div className="flex px-4 py-2 border-b border-[#BECBD3] text-[#434852] text-[16px] font-medium items-center w-full">
        Crop Your Image
        <button onClick={onClose} type="button" className="ms-auto w-8 h-8 inline-flex justify-center items-center">
          <CloseModalImg className="w-3 h-3" />
        </button>
      </div>

      <div className="flex items-cente max-w-[50vw] justify-between flex-col px-3">
        <div className="w-full  h-full px-4 py-1">
          <Cropper
            ref={cropperRef}
            src={image}
            className="cropper"
            stencilProps={{
              aspectRatio: 1,
            }}
            imageRestriction="none" // allow full freedom
          />
        </div>

        <div className="flex gap-4 justify-center py-3">
          <button className="bg-primary-90 text-white px-4 py-2 rounded hover:primary font-medium" onClick={handleCrop}>
            Crop & Set
          </button>
          <button className="bg-[#F4F4F4] text-black px-4 py-2 rounded hover:bg-[#D2DAE1]" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CropComponent;
